import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { errorMessage } from '../admin/adminApi';
import { formatDate } from '../admin/format';
import { OFFICE_LABELS } from './offices';
import { Panel, Spinner } from '../admin/AdminUI';
import { originLabel } from '../approvals/StepTrail';
import { DecisionStatus, decisionTitle } from './DecisionsTab';

function Tile({ label, value }) {
  return (
    <Panel>
      <p className="text-xs text-muted-foreground">{label}</p>
      <p className="text-3xl font-bold text-foreground mt-1">{value}</p>
    </Panel>
  );
}

function DecisionList({ slug, decisions, empty }) {
  if (decisions.length === 0) return <p className="text-sm text-muted-foreground">{empty}</p>;
  return (
    <ul className="divide-y divide-border">
      {decisions.map((d) => (
        <li key={d._id} className="py-2 flex items-center gap-3">
          <div className="min-w-0 flex-1">
            <Link to={`/council/${slug}/decisions?${d.waiting ? '' : 'status=decided&'}decision=${d._id}`} className="text-sm font-medium text-foreground hover:text-primary">{decisionTitle(d)}</Link>
            <p className="text-xs text-muted-foreground">{originLabel(d.origin) || 'Proposed'} · {formatDate(d.createdAt)}</p>
          </div>
          <DecisionStatus decision={d} />
        </li>
      ))}
    </ul>
  );
}

function CouncilDashboardTab({ slug, api }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/${slug}/dashboard`).then((r) => setData(r.data)).catch((err) => alert(errorMessage(err, 'Failed to load the dashboard')));
  }, [api, slug]);

  if (!data) return <Spinner />;
  const { counts } = data;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Tile label="Waiting for your vote" value={counts.waitingForMe} />
        <Tile label="Waiting for council" value={counts.waiting} />
        <Tile label="Decided in the last 30 days" value={counts.decidedLast30Days} />
        <Tile label="Council members" value={counts.members} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Panel className="lg:col-span-2">
          <div className="flex items-center mb-2">
            <h2 className="text-sm font-semibold text-foreground">Waiting for council</h2>
            <Link to={`/council/${slug}/decisions`} className="ml-auto text-sm text-primary">All decisions →</Link>
          </div>
          <DecisionList slug={slug} decisions={data.waiting} empty="Nothing is waiting for council." />
          <h2 className="text-sm font-semibold text-foreground mt-6 mb-2">Recently decided</h2>
          <DecisionList slug={slug} decisions={data.recent} empty="No decisions yet." />
        </Panel>
        <Panel>
          <h2 className="text-sm font-semibold text-foreground mb-2">Council</h2>
          <ul className="space-y-1 text-sm">
            {data.members.map((m) => (
              <li key={m._id} className="flex gap-2">
                <span className="text-foreground">{m.user.name}</span>
                <span className="text-muted-foreground ml-auto">{OFFICE_LABELS[m.office]}</span>
              </li>
            ))}
          </ul>
          {data.members.length === 0 && <p className="text-sm text-muted-foreground">No council members yet. The Admin adds them in Condo settings.</p>}
        </Panel>
      </div>
    </div>
  );
}

export default CouncilDashboardTab;
